<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="card h-100 mt-3">
          <div class="card-header mb-0">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-3">{{ $t('content.gdashboard') }}</h5>
              <div class="col-12 col-lg-4">
                <select v-model="shop_seleted" class="form-select profile" :onclick='selectProfile()'
                  :disabled="shopList.length === 0">
                  <option value="0" disabled selected>{{ $t("content.amnselprofile") }}</option>
                  <option v-for="(item, index) in shopList" :value="item" :key="index">
                    {{ item.nameTh }} ( {{ item.nameEn }} )
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="card-body pt-0" v-if="shop_seleted !== '0'">
            <div class="row">
              <div class="col-6 text-center">
                <h5 class="mt-4 mb-0">
                  {{ $t("content.numberactive") }}
                </h5>
                <div>
                  <h5 class="mb-0 text-info">
                    <b>
                      <span v-if="shop_seleted !== '0' && loading">
                        {{ formatNumberString(dataInfo.numOfActiveWorkCase) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h5>
                </div>
              </div>
              <div class="col-6 text-center">
                <h5 class="mt-4 mb-0">
                  {{ $t("content.numberpostpone") }}
                </h5>
                <div>
                  <h5 class="mb-0 text-info">
                    <b>
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfPostponeWorkCase) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h5>
                </div>
              </div>
            </div>
            <pre></pre>
            <div class="row">
              <div class="col-lg-4 me-3">
                <span class="form-label m-0">{{ $t("content.sdate") }}</span>
                <div class="d-inline-block mx-4">
                  <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                    :max-date="new Date()" :enable-time-picker="false" month-name-format="long" :clearable="false"
                    :text-input="textInputOptions" fluid />
                </div>
              </div>
              <div class="col-lg-4 me-3">
                <span class="form-label m-0">{{ $t("content.edate") }}</span>
                <div class="d-inline-block mx-4">
                  <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true" :max-date="new Date()"
                    :enable-time-picker="false" month-name-format="long" :clearable="false"
                    :text-input="textInputOptions" fluid />
                </div>
              </div>
              <div class="col-lg-2 me-3">
                <span class="form-label m-0"></span>
                <div class="d-inline-block mx-4">
                  <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                    @click="loadDataInfoApi" :disabled="monthDiff() || start_date > end_date">
                    <i class="material-icons material-symbols-outlined">search</i>
                    {{ search }}
                  </material-button>
                  <material-button data-bs-toggle="modal" data-bs-target="#detailUserWorkModal" id="userWorkModalShow"
                    v-show="false">
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4 text-center">
                <h5 class="mt-4 mb-0">
                  <b> {{ $t("content.amnenter") }} </b>
                </h5>
                <div>
                  <h2 class="mb-0 text-info">
                    <b>
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfCustomer) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h2>
                </div>
              </div>

              <div class="col-2 text-center">
                <h5 class="mt-4 mb-0">
                  <b> {{ $t("content.numOfCancel") }} </b>
                </h5>
                <div>
                  <h2 class="mb-0 text-info">
                    <b style="color:red;">
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfCancelTicket) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h2>
                </div>
              </div>

              <div class="col-3 text-center">
                <h5 class="mt-4 mb-0">
                  <b> {{ $t("content.numOfTerminate") }} </b>
                </h5>
                <div>
                  <h2 class="mb-0 text-info">
                    <b style="color:orange;">
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfTerminate) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h2>
                </div>
              </div>

              <!-- <div class="col-2 text-center">
                <h6 class="mt-4 mb-0">
                  <b>
                    numOfVoidTicket
                  </b>
                </h6>
                <div>
                  <h3 class="mb-0 text-info">
                    <b style="color:orange;">
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfVoidTicket) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h3>
                </div>
              </div> -->

              <div class="col-3 text-center">
                <h5 class="mt-4 mb-0">
                  <b>
                    {{ $t("content.editafcom") }}
                  </b>
                </h5>

                <div>
                  <h2 class="mb-0 text-info">
                    <b style="color:#656A60;">
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfEditAfterComplete) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 text-center">
                <h5 class="mt-4 mb-0">
                  {{ $t("content.numberotp") }}
                </h5>
                <div>
                  <h5 class="mb-0 text-info">
                    <b>
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfOtp) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h5>
                </div>
              </div>
              <div class="col-6 text-center">
                <h5 class="mt-4 mb-0">
                  {{ $t("content.numberotpmi") }}
                </h5>
                <div>
                  <h5 class="mb-0 text-info">
                    <b>
                      <span v-if="loading">
                        {{ formatNumberString(dataInfo.numOfOtpMigration) }}
                      </span>
                      <span v-else>
                        0
                      </span>
                    </b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="shop_seleted !== '0'">
      <div class="col-lg-12 mb-2">
        <div class="card h-100 mt-2">
          <div class="h-100 mt-2">
            <div class="p-3 pb-0 card-header">
              <div class="d-flex justify-content-between">
                <h5 class="mb-0">
                  <b>{{ $t("content.workProcess") }}
                  </b>
                </h5>
              </div>
            </div>

            <div class="card-body pt-0">
              <div class="row">
                <div class="col-2 text-center">
                  <h5 class="mt-4 mb-0">
                    <span v-if="list_q01.length > 0" @click="viewUserWorkDetail('Q01')"
                      style="text-decoration:underline;cursor: pointer">
                      {{ $t("content.workQ01") }}
                    </span>
                    <span v-else>
                      {{ $t("content.workQ01") }}
                    </span>
                  </h5>
                  <div>
                    <h5 class="mb-0 text-info">
                      <b>
                        <span v-if="loading">
                          {{ formatNumberString(num_q01) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>

                <div class="col-3 text-center">
                  <h5 class="mt-4 mb-0">
                    <span v-if="list_q02.length > 0" @click="viewUserWorkDetail('Q02')"
                      style="text-decoration:underline;cursor: pointer">
                      {{ $t("content.workQ02") }}
                    </span>
                    <span v-else>
                      {{ $t("content.workQ02") }}
                    </span>
                  </h5>
                  <div>
                    <h5 class="mb-0 text-info">
                      <b>
                        <span v-if="loading">
                          {{ formatNumberString(num_q02) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>


                <div class="col-3 text-center">
                  <h5 class="mt-4 mb-0">
                    <span v-if="list_q03.length > 0" @click="viewUserWorkDetail('Q03')"
                      style="text-decoration:underline;cursor: pointer">
                      {{ $t("content.workQ03") }}
                    </span>
                    <span v-else>
                      {{ $t("content.workQ03") }}</span>
                  </h5>
                  <div>
                    <h5 class="mb-0 text-info">
                      <b>
                        <span v-if="loading">
                          {{ formatNumberString(num_q03) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>

                <div class="col-2 text-center">
                  <h5 class="mt-4 mb-0">
                    <span v-if="list_q04.length > 0" @click="viewUserWorkDetail('Q04')"
                      style="text-decoration:underline;cursor: pointer">
                      {{ $t("content.workQ04") }}
                    </span>
                    <span v-else>
                      {{ $t("content.workQ04") }}
                    </span>
                  </h5>
                  <div>
                    <h5 class="mb-0 text-info">
                      <b>
                        <span v-if="loading">
                          {{ formatNumberString(num_q04) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>

                <div class="col-2 text-center">
                  <h5 class="mt-4 mb-0">
                    <span v-if="list_pay.length > 0" @click="viewUserWorkDetail('QPAY')"
                      style="text-decoration:underline;cursor: pointer">
                      {{ $t("content.workQpay") }}
                    </span>
                    <span v-else>
                      {{ $t("content.workQpay") }}
                    </span>
                  </h5>
                  <div>
                    <h5 class="mb-0 text-info">
                      <b>
                        <span v-if="loading">
                          {{ formatNumberString(num_pay) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="card h-100 mt-2">
          <div class="row mb-2">
            <div class="col-lg-12 mb-2">
              <div class="h-100 mt-2">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h5 class="mb-0">
                      <b>{{ $t("content.oldsystemsinfo") }}
                      </b>
                    </h5>
                  </div>
                </div>

                <div class="card-body pt-0">
                  <div class="row">
                    <div class="col-2">
                      <h5 class="mt-4 mb-0 text-start">
                        {{ $t("content.pawntktotal") }} :&nbsp;
                        <span style="color: red;">
                          <b>{{ formatNumberString(sum_pawncase) }}</b>
                        </span>
                      </h5>
                    </div>

                    <div class="col-4">
                      <h5 class="mt-4 mb-0 text-start">
                        {{ $t("content.pawntotal") }} ({{
                          $t("content.newtktotal")
                        }}) :&nbsp;
                        <span style="color: red;">
                          <b>{{ formatDecimalString(sum_pawnvalue) }}</b>
                        </span>
                      </h5>
                    </div>

                    <div class="col-2">
                      <h5 class="mt-4 mb-0 text-start">
                        {{ $t("content.redeemtktotal") }} :&nbsp;
                        <span style="color: green;">
                          <b>{{ formatNumberString(sum_redeemcase) }}</b>
                        </span>
                      </h5>
                    </div>

                    <div class="col-4">
                      <h5 class="mt-4 mb-0 text-start">
                        {{ $t("content.redeemtotal") }} ({{
                          $t("content.oldtktotal")
                        }}) :&nbsp;
                        <span style="color: green;">
                          <b>{{ formatDecimalString(sum_redeemvalue) }}</b>
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-7 mb-2">
              <div class="h-100 mt-2">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h5 class="mb-0">
                      <b>{{ $t("content.ovrtransnor") }} :&nbsp;
                        <span class="mb-0 text-info" v-if="loading">
                          {{ formatNumberString(Number(dataInfo.numOfPawn) +
                            Number(dataInfo.numOfInterest) +
                            Number(dataInfo.numOfInc) +
                            Number(dataInfo.numOfDec) +
                            Number(dataInfo.numOfRedeem)) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>
                  </div>
                </div>
                <div class="p-3 mt-4 card-body">
                  <table class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[0].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn1") }}
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfPawn)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td colspan="3" class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{ formatDecimalString(dataInfo.pawnValue)
                            }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[1].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn2") }}
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfInterest)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.interestPawnValue)
                            }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amninterest") }}&nbsp;
                            {{ formatDecimalString(dataInfo.interestAmount)
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[2].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn3") }}
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfInc)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{ formatDecimalString(dataInfo.incPawnValue) }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amninterest") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.incInterestAmount)
                            }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amncashdrawerdiff") }}&nbsp;
                            {{ formatDecimalString(dataInfo.incDiff) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[3].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn4") }}
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfDec)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{ formatDecimalString(dataInfo.decPawnValue) }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amninterest") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.decInterestAmount)
                            }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amncashdrawerdiff") }}&nbsp;
                            {{ formatDecimalString(dataInfo.decDiff) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[4].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn5") }}
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfRedeem)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{ formatDecimalString(dataInfo.redeemPawnValue)
                            }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.amninterest") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.redeemInterestAmount)
                            }}
                          </span>
                        </td>
                      </tr>
                      <pre></pre>
                      <tr>
                        <td colspan="2" class="fs-14 text-bold">
                          <span class="text-md text-dark">
                            {{ $t("content.actpawn1") }},{{
                              $t("content.actpawn3") }} :&nbsp;
                            <span style="color: red;">
                              {{ formatDecimalString(sum_painvalue) }}
                            </span> </span>
                        </td>
                        <td colspan="2" class="fs-14 text-bold">
                          <span class="text-md text-dark">
                            {{ $t("content.actpawn2") }},{{
                              $t("content.actpawn4") }},{{
                              $t("content.actpawn5") }}
                            :&nbsp;
                            <span style="color: green;">
                              {{ formatDecimalString(sum_inderevalue) }}
                            </span>

                          </span>
                        </td>
                      </tr>
                      <pre></pre>
                      <tr>
                        <td colspan="2" class="fs-14 text-bold">
                          <span class="text-md text-dark">
                            {{ $t("content.sumvalticket") }} :&nbsp;
                            <span style="color: blue;">
                              {{ formatDecimalString(sum_pvalue) }}
                            </span>
                          </span>
                        </td>
                        <td colspan="2" class="fs-14 text-bold">
                          <span class="text-md text-dark">
                            {{ $t("content.sumintticket") }} :&nbsp;
                            <span style="color: green;">
                              {{ formatDecimalString(sum_intvalue) }}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-lg-5 mb-4">
              <div class="h-100 mt-3">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h5 class="mb-0">
                      <b>{{ $t("content.ovrtransmig") }} :&nbsp;
                        <span class="mb-0 text-info" v-if="loading">
                          {{
                            formatNumberString(Number(dataInfo.numOfInterestMigration)
                              +
                              Number(dataInfo.numOfIncMigration) +
                              Number(dataInfo.numOfDecMigration)) }}
                        </span>
                        <span v-else>
                          0
                        </span>
                      </b>
                    </h5>

                  </div>
                </div>
                <div class="p-3 mt-4 card-body">
                  <table class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[1].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn2") }} ({{
                                $t("content.transmig")
                              }})
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfInterestMigration)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.interestPawnValueMigration)
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[2].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn3") }} ({{
                                $t("content.transmig")
                              }})
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfIncMigration)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.incPawnValueMigration)
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i :class="legendTimes[3].bg"></i>
                            <span class="text-md text-dark">{{
                              $t("content.actpawn4") }} ({{
                                $t("content.transmig")
                              }})
                              <span class="mb-0 text-info">
                                ({{
                                  formatNumberString(dataInfo.numOfDecMigration)
                                }})
                              </span>
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.valticket") }}&nbsp;
                            {{
                              formatDecimalString(dataInfo.decPawnValueMigration)
                            }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i></i>
                            <span class="text-md text-dark"></span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-14 text-start" width=15>
                          <span class="badge badge-md badge-dot me-4 d-block text-start">
                            <i></i>
                            <span class="text-md text-dark"></span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          <span class="text-md text-dark"> </span>
                        </td>
                      </tr>
                      <pre></pre>
                      <tr>
                        <td colspan="2" class="fs-14 text-bold">
                          <span class="text-md text-dark"> {{
                            $t("content.sumvalticket") }} :&nbsp;
                            <span style="color: red;">
                              {{ formatDecimalString(sum_mvalue) }}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card h-100 mt-3">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <b>{{ $t("content.amnqty") }}</b>
              </h5>

              <h2 class="mb-0 text-info">
                <b>
                  {{ formatNumberString(dataInfo.numOfWorkCase) }}
                </b>
              </h2>
            </div>
          </div>
          <div class="p-3 mt-4 card-body">
            <div class="row">
              <div class="col-7 text-start" v-if="loading">
                <pie-chart id="chart-times" :chart="{
                  labels: [plegde, interest, addcap, reducecap, redeem],
                  datasets: {
                    label: 'Projects',
                    data: [
                      legendTimes[0].dt,
                      legendTimes[1].dt,
                      legendTimes[2].dt,
                      legendTimes[3].dt,
                      legendTimes[4].dt,
                    ],
                    backgroundColor: colors,
                  },
                }" />
              </div>
              <div class="my-auto col-5">
                <span v-for="(i, pt1) in legendTimes" :key="pt1"
                  class="badge badge-md badge-dot me-4 d-block text-start">
                  <i :class="i.bg"></i>
                  <span class="text-md text-dark">{{ i.hd }} ({{ fmNumber(i.dt)
                  }})</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card h-100 mt-3">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <b>{{ $t("content.amnmoney") }}</b>
              </h5>
            </div>
          </div>
          <div class="p-3 mt-4 card-body">
            <div class="row">
              <div class="col-7 text-start" v-if="loading">
                <pie-chart id="chart-baht" :chart="{
                  labels: [plegde, interest, addcap, reducecap, redeem],
                  datasets: {
                    label: 'Projects',
                    data: [
                      legendBaht[0].dt,
                      legendBaht[1].dt,
                      legendBaht[2].dt,
                      legendBaht[3].dt,
                      legendBaht[4].dt,
                    ],
                    backgroundColor: colors,
                  },
                }" />
              </div>
              <div class="my-auto col-5">
                <span v-for="(i, pt2) in legendBaht" :key="pt2"
                  class="badge badge-md badge-dot me-4 d-block text-start">
                  <i :class="i.bg"></i>
                  <span class="text-md text-dark">{{ i.hd }} ({{
                    formatNumberDecimalString(i.dt) }})</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card h-100 mt-3">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <b>{{ $t("content.amncashflow") }}</b>
              </h5>
            </div>
          </div>
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0 text-info">
                <b>
                  <span class="text-md text-dark">{{ $t("content.amnoutcome") }} :
                  </span>
                  <span style="color:red">
                    {{ formatDecimalString(dataInfo.payAmount) }}
                  </span>
                </b>
              </h6>
              <h6 class="mb-0 text-info">
                <b>
                  <span class="text-md text-dark">{{ $t("content.amnincome") }} :
                  </span>
                  <span style="color:green">
                    {{ formatDecimalString(dataInfo.receiveAmount) }}
                  </span>
                </b>
              </h6>

              <h6 class="mb-0 text-info">
                <b>
                  <span class="text-md text-dark">{{ $t("content.amninterest") }} :
                  </span>
                  <span class="text-info">
                    {{ formatDecimalString(dataInfo.sumInterest) }}
                  </span>
                </b>
              </h6>
            </div>
          </div>
          <div class="p-3 mt-4 card-body">
            <div class="row">
              <div class="col-7 text-start" v-if="loading">
                <pie-chart id="chart-sum" :chart="{
                  labels: [sincome, soutcome, sinterest],
                  datasets: {
                    label: 'Projects',
                    data: [
                      legendSum[1].dt,
                      legendSum[0].dt,
                      legendSum[2].dt,
                    ],
                    backgroundColor: colors2,
                  },
                }" />
              </div>
              <div class="my-auto col-5">
                <span v-for="(i, pt2) in legendSum" :key="pt2" class="badge badge-md badge-dot me-4 d-block text-start">
                  <i :class="i.bg"></i>
                  <span class="text-md text-dark">{{ i.hd }} ({{
                    formatNumberDecimalString(i.dt) }})</span>
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card h-100 mt-3">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <b>{{ $t("content.amnmigflow") }}</b>
              </h5>
            </div>
          </div>
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0 text-info">
                <b>
                  <span class="text-md text-dark">{{ $t("content.amnoutcome") }} :
                  </span>
                  <span style="color:red">
                    {{ formatDecimalString(dataInfo.totalPayMigration) }}
                  </span>
                </b>
              </h6>
              <h6 class="mb-0 text-info">
                <b>
                  <span class="text-md text-dark">{{ $t("content.amnincome") }} :
                  </span>
                  <span style="color:green">
                    {{ formatDecimalString(dataInfo.totalReceiveMigration) }}
                  </span>
                </b>
              </h6>
            </div>
          </div>
          <div class="p-3 mt-4 card-body">
            <div class="row">
              <div class="col-7 text-start" v-if="loading">
                <pie-chart id="chart-mig" :chart="{
                  labels: [interest, addcap, reducecap],
                  datasets: {
                    label: 'Projects',
                    data: [
                      legendMig[0].dt,
                      legendMig[1].dt,
                      legendMig[2].dt,
                    ],
                    backgroundColor: colors,
                  },
                }" />
              </div>
              <div class="my-auto col-5">
                <span v-for="(i, pt2) in legendMig" :key="pt2" class="badge badge-md badge-dot me-4 d-block text-start">
                  <i :class="i.bg"></i>
                  <span class="text-md text-dark">{{ i.hd }} {{
                    formatDecimalString(i.dt) }} ({{ fmNumber(i.dt2)
                    }})</span>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>



      <!-- Detail UserWork Modal -->
      <div class="modal fade" id="detailUserWorkModal" tabindex="-1" aria-labelledby="detailUserWorkLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width:750px;">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="detailUserWorkModalLabel">
                <span v-if="userq === 'Q01'">
                  {{ $t("content.workQ01") }} : {{ formatNumberString(num_q01) }}
                </span>
                <span v-else-if="userq === 'Q02'">
                  {{ $t("content.workQ02") }} : {{ formatNumberString(num_q02) }}
                </span>
                <span v-else-if="userq === 'Q03'">
                  {{ $t("content.workQ03") }} : {{ formatNumberString(num_q03) }}
                </span>
                <span v-else-if="userq === 'Q04'">
                  {{ $t("content.workQ04") }} : {{ formatNumberString(num_q04) }}
                </span>
                <span v-else-if="userq === 'QPAY'">
                  {{ $t("content.workQpay") }} : {{ formatNumberString(num_pay) }}
                </span>
              </h1>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <i class="material-icons material-symbols-outlined">close</i>
              </button>
            </div>
            <div class="modal-body">
              <table class="table table-sm table-borderless">
                <tbody>
                  <tr>
                    <td class="text-dark">
                      <h6><b>
                          #
                        </b>
                      </h6>
                    </td>
                    <td class="text-dark">
                      <h6><b>
                          {{ $t("content.amnlastmaker") }}
                        </b>
                      </h6>
                    </td>
                    <td class="text-dark text-center">
                      <h6><b>
                          {{ $t("content.jobqtyitem") }}
                        </b>
                      </h6>
                    </td>
                  </tr>
                  <tr v-for="(row, index) in list_userq" :key="index">
                    <td class="text-md text-dark">
                      {{ formatNumberString(index + 1) }}
                    </td>
                    <td class="text-md text-info">
                      <span v-if="row.ownerUid !== '0'">
                        {{ row.ownerName }}
                      </span>
                      <span v-else style="color:red;">
                        {{ $t("content.nojobowner") }}
                      </span>
                    </td>
                    <td class="text-md text-info text-center">
                      <span v-if="row.ownerUid !== '0'">
                        {{ formatNumberString(sumUserWork(row.ownerUid)) }}
                      </span>
                      <span v-else style="color:red;">
                        {{ formatNumberString(sumUserWork(row.ownerUid)) }}
                      </span>
                    </td>

                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-12 mb-4">
        <div class="card h-100 mt-3">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <b>{{ $t("content.amndue") }}</b>
              </h5>
            </div>
          </div>
          <div class="p-3 mt-2 card-body">
            <div class="row">
              <div v-for="(a, pt3) in legendDue" :key="pt3" class="col-12 text-start mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="mb-1">{{ a.hd }}</p>
                  <div class="d-flex align-items-center">
                    <h4 class="mb-0">
                      <b><span :class="a.tx">{{ fmNumber(a.vs) }}</span></b>
                    </h4>
                    &nbsp;
                    <p class="text-sm mb-0">/{{ fmNumber(a.vm) }}</p>
                  </div>
                </div>

                <div class="progress dashboard">
                  <div v-if="a.vs !== 0 && a.vm !== 0" class="progress-bar" :class="a.bg" role="progressbar"
                    :style="'width: ' + calPercent(a.vs, a.vm) + '%;'" :aria-valuenow="calPercent(a.vs, a.vm)"
                    aria-valuemin="0" aria-valuemax="100">
                    {{ Number(calPercent(a.vs, a.vm)).toLocaleString() }}%
                  </div>
                  <div v-else class="progress-bar" :class="a.bg" role="progressbar" :style="'width: ' + 2 + '%;'"
                    :aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                    0%
                  </div>
                </div>
              </div>
            </div>



            <div class="row mt-4" style="overflow-x: auto; padding-right: 1em">
              <h5 class="">{{ $t("content.amnticketduelist") }}</h5>
              <div class="table-responsive">
                <table class="table">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.amnduedate") }}</th>
                      <th>{{ $t("content.names") }}</th>
                      <th>{{ $t("content.ticketno") }}</th>
                      <th>{{ $t("content.allweight") }}</th>
                      <th>{{ $t("content.allqty") }}</th>
                      <th>{{ $t("content.allprice") }}</th>
                      <th>{{ $t("content.cintrate") }}</th>
                      <th>{{ $t("content.act") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in duelist" :key="index">
                      <td class="text-sm font-weight-normal">{{
                        formatNumberString((currentPage - 1) * perPage + index
                          +
                          1) }}</td>
                      <td class="text-sm font-weight-normal">
                        {{ format_date(row.dueDate) }}</td>
                      <td class="text-sm font-weight-normal">
                        <span @click="searchCustomer(row)" style="color:blue;text-decoration:underline;cursor: pointer">
                          {{ row.cusName }}
                        </span>
                        <material-button data-bs-toggle="modal" data-bs-target="#exampleModal" id="exampleModalShow"
                          v-show="false">
                        </material-button>
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.refNumber }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.weight) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberString(row.quantity) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.newPawnValue) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.interestPerMonth) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="info" variant="outline" class="rounded-circle"
                          :title="t('buttons.seed')" @click="openDetail(row)">
                          <i class="material-icons material-symbols-outlined">visibility</i>
                        </material-button>
                        <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                          data-bs-toggle="modal" data-bs-target="#lookupModal" id="detailModal">
                        </material-button>
                      </td>
                    </tr>
                    <tr v-if="duelist.length === 0">
                      <td colspan="11" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="14" style="text-align: right">Total Rows : {{
                        totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="duelist.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                      @click="onClickHandler" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ref, reactive, computed, inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import PieChart from "@/examples/Charts/PieChart.vue";
import moment from 'moment'


import { useDashboardStore } from '@/stores/dashboard'
import { useWorkItemStore } from '@/stores/workItem'

const storedash = useDashboardStore()
const storew = useWorkItemStore()


///// variables
const { t } = useI18n();
const swal = inject("$swal");

const start_date = ref(new Date());
const end_date = ref(new Date());
const sum_pvalue = ref(0);
const sum_mvalue = ref(0);
const sum_painvalue = ref(0);
const sum_inderevalue = ref(0);
const sum_intvalue = ref(0);
const sum_pawncase = ref(0);
const sum_pawnvalue = ref(0);
const sum_redeemcase = ref(0);
const sum_redeemvalue = ref(0);
const num_q01 = ref(0);
const num_q02 = ref(0);
const num_q03 = ref(0);
const num_q04 = ref(0);
const num_pay = ref(0);
const list_q01 = ref([]);
const list_q02 = ref([]);
const list_q03 = ref([]);
const list_q04 = ref([]);
const list_pay = ref([]);
const user_q01 = ref([]);
const user_q02 = ref([]);
const user_q03 = ref([]);
const user_q04 = ref([]);
const user_pay = ref([]);
const userq = ref('');
const list_userq = ref([]);

const shopList = ref([]);
const shop_seleted = ref();

const dataInfo = ref({
  pawnValue: 0,
  interestPawnValue: 0,
  incPawnValue: 0,
  decPawnValue: 0,
  redeemPawnValue: 0,
  interestPawnValueMigration: 0,
  incPawnValueMigration: 0,
  decPawnValueMigration: 0,
  interestAmount: 0,
  incInterestAmount: 0,
  decInterestAmount: 0,
  redeemInterestAmount: 0,
  numOfPawn: 0,
  numOfInterest: 0,
  numOfInc: 0,
  numOfDec: 0,
  numOfInterestMigration: 0,
  numOfIncMigration: 0,
  numOfDecMigration: 0,
  numOfRedeem: 0,
  numOfRedeemInterest: 0,
  numOfCustomer: 0,
  numOfWorkCase: 0,
  numOfActiveWorkCase: 0,
  numOfPostponeWorkCase: 0,
  numOfVoidTicket: 0,
  numOfEditAfterComplete: 0,
  pawnAmount: 0,
  incAmount: 0,
  incDiff: 0,
  decAmount: 0,
  decDiff: 0,
  redeemAmount: 0,
  payAmount: 0,
  receiveAmount: 0,
  sumInterest: 0,
  interestAmountMigration: 0,
  interestTotalPayMigration: 0,
  interestTotalReceiveMigration: 0,
  incAmountMigration: 0,
  incTotalPayMigration: 0,
  incTotalReceiveMigration: 0,
  decAmountMigration: 0,
  decTotalPayMigration: 0,
  decTotalReceiveMigration: 0,
  totalPayMigration: 0,
  totalReceiveMigration: 0,
  numOfCancelTicket: 0,
  numOfTerminate: 0,
  numOfOtp: 0,
  numOfOtpMigration: 0,
})


const allqueuelist = ref([])
const allpaymentlist = ref([])


const colors = reactive(["#809bce", "#95b8d1", "#b8e0d2", "#d6eadf", "#eac4d5"]);
const colors2 = reactive(["#dfffdd", "#fecac7", "#b8e0d2"]);

const loading = ref(false)

const legendTimes = ref([{
  bg: "bg-pledge",
  hd: computed(() => t("content.actpawn1")),
  dt: Number(0),
},
{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
},
{
  bg: "bg-redeem",
  hd: computed(() => t("content.actpawn5")),
  dt: Number(0),
},]);

const legendBaht = ref([
  {
    bg: "bg-pledge",
    hd: computed(() => t("content.actpawn1")),
    dt: Number(0)
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.actpawn2")),
    dt: Number(0),
  },
  {
    bg: "bg-add-cap",
    hd: computed(() => t("content.actpawn3")),
    dt: Number(0),
  },
  {
    bg: "bg-reduce-cap",
    hd: computed(() => t("content.actpawn4")),
    dt: Number(0),
  },
  {
    bg: "bg-redeem",
    hd: computed(() => t("content.actpawn5")),
    dt: Number(0),
  },
]);

const legendSum = ref([
  {
    bg: "bg-payment",
    hd: computed(() => t("content.amnoutcome")),
    dt: Number(0)
  },
  {
    bg: "bg-receive",
    hd: computed(() => t("content.amnincome")),
    dt: Number(0),
  },
  {
    bg: "bg-interest",
    hd: computed(() => t("content.amninterest")),
    dt: Number(0),
  },
]);

const legendMig = ref([{
  bg: "bg-interest",
  hd: computed(() => t("content.actpawn2")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-add-cap",
  hd: computed(() => t("content.actpawn3")),
  dt: Number(0),
  dt2: Number(0),
},
{
  bg: "bg-reduce-cap",
  hd: computed(() => t("content.actpawn4")),
  dt: Number(0),
  dt2: Number(0),
},]);

///// computed
const plegde = computed(() => t("content.actpawn1"))
const interest = computed(() => t("content.actpawn2"))
const addcap = computed(() => t("content.actpawn3"))
const reducecap = computed(() => t("content.actpawn4"))
const redeem = computed(() => t("content.actpawn5"))
const search = computed(() => t("buttons.sear"));


const loadDataInfoApi = async () => {
  dataInfo.value.pawnValue = 0
  dataInfo.value.interestPawnValue = 0
  dataInfo.value.incPawnValue = 0
  dataInfo.value.decPawnValue = 0
  dataInfo.value.redeemPawnValue = 0
  dataInfo.value.interestAmount = 0
  dataInfo.value.incInterestAmount = 0
  dataInfo.value.decInterestAmount = 0
  dataInfo.value.redeemInterestAmount = 0
  dataInfo.value.numOfPawn = 0
  dataInfo.value.numOfInterest = 0
  dataInfo.value.numOfInc = 0
  dataInfo.value.numOfDec = 0
  dataInfo.value.numOfInterestMigration = 0
  dataInfo.value.numOfIncMigration = 0
  dataInfo.value.numOfDecMigration = 0
  dataInfo.value.numOfRedeem = 0
  dataInfo.value.numOfRedeemInterest = 0
  dataInfo.value.numOfCustomer = 0
  dataInfo.value.numOfWorkCase = 0
  dataInfo.value.numOfActiveWorkCase = 0
  dataInfo.value.numOfPostponeWorkCase = 0
  dataInfo.value.numOfVoidTicket = 0
  dataInfo.value.numOfEditAfterComplete = 0
  dataInfo.value.pawnAmount = 0
  dataInfo.value.incAmount = 0
  dataInfo.value.incDiff = 0
  dataInfo.value.decAmount = 0
  dataInfo.value.decDiff = 0
  dataInfo.value.redeemAmount = 0
  dataInfo.value.payAmount = 0
  dataInfo.value.receiveAmount = 0
  dataInfo.value.sumInterest = 0
  dataInfo.value.interestAmountMigration = 0
  dataInfo.value.interestTotalPayMigration = 0
  dataInfo.value.interestTotalReceiveMigration = 0
  dataInfo.value.incAmountMigration = 0
  dataInfo.value.incTotalPayMigration = 0
  dataInfo.value.incTotalReceiveMigration = 0
  dataInfo.value.decAmountMigration = 0
  dataInfo.value.decTotalPayMigration = 0
  dataInfo.value.decTotalReceiveMigration = 0
  dataInfo.value.totalPayMigration = 0
  dataInfo.value.totalReceiveMigration = 0
  dataInfo.value.numOfCancelTicket = 0
  dataInfo.value.numOfTerminate = 0
  dataInfo.value.numOfOtp = 0
  dataInfo.value.numOfOtpMigration = 0
  sum_pvalue.value = 0
  sum_mvalue.value = 0;
  sum_painvalue.value = 0;
  sum_inderevalue.value = 0;
  sum_intvalue.value = 0;
  sum_pawncase.value = 0;
  sum_pawnvalue.value = 0;
  sum_redeemcase.value = 0;
  sum_redeemvalue.value = 0;
  loading.value = false
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  let data = "";
  data = {
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    shopUid: key.uid
  };
  const payload = data;
  const response = await storedash.dashboardInfoFetch(payload);
  // console.log('dataInfo : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        dataInfo.value = response.data.data;
        setnumOfTransaction()
        setnumOfAmount()
        setnumOfSum()
        setnumOfMig()
        sum_pvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_mvalue.value = dataInfo.value.interestPawnValueMigration + dataInfo.value.incPawnValueMigration
          + dataInfo.value.decPawnValueMigration;
        sum_painvalue.value = dataInfo.value.pawnValue + dataInfo.value.incPawnValue
        sum_inderevalue.value = dataInfo.value.interestPawnValue + dataInfo.value.decPawnValue + dataInfo.value.redeemPawnValue;
        sum_intvalue.value = dataInfo.value.interestAmount + dataInfo.value.incInterestAmount + dataInfo.value.decInterestAmount
          + dataInfo.value.redeemInterestAmount;
        sum_pawncase.value = Number(dataInfo.value.numOfPawn) + Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec)
          + Number(dataInfo.value.numOfInterestMigration) + Number(dataInfo.value.numOfIncMigration) + Number(dataInfo.value.numOfDecMigration);
        sum_pawnvalue.value = dataInfo.value.pawnValue + dataInfo.value.interestPawnValue + dataInfo.value.incPawnValue
          + dataInfo.value.decPawnValue + sum_mvalue.value;
        sum_redeemcase.value = Number(dataInfo.value.numOfInterest) + Number(dataInfo.value.numOfInc) + Number(dataInfo.value.numOfDec) + Number(dataInfo.value.numOfRedeem);
        sum_redeemvalue.value = dataInfo.value.interestPawnValue + (dataInfo.value.incPawnValue - dataInfo.value.incDiff)
          + (dataInfo.value.decPawnValue + dataInfo.value.decDiff) + dataInfo.value.redeemPawnValue;
        loading.value = true
      }
    }
  }
}

const loadDataList = async () => {
  // console.log("load dash : ", localStorage.getItem("shop_seleted"));
  if (localStorage.getItem("shoplist") !== null) {
    shopList.value = JSON.parse(localStorage.getItem("shoplist"));
    // console.log("shopList dash : ", shopList.value);
  }

  if (localStorage.getItem("shop_seleted") !== null) {
    shop_seleted.value = JSON.parse(localStorage.getItem("shop_seleted"));
    await loadDataInfoApi()
    loadAllQueueApi()
  } else {
    shop_seleted.value = '0'
  }
};

loadDataList();


async function selectProfile() {
  if (window.location.href.indexOf("signin") == -1) {
    if (shop_seleted.value !== null && shop_seleted.value !== '0') {
      // console.log("selectProfile dash : " + JSON.stringify(shop_seleted.value));
      if (localStorage.getItem("shop_seleted") !== null) {
        const old_shop = JSON.parse(localStorage.getItem("shop_seleted"));
        if (shop_seleted.value.uid !== old_shop.uid) {
          reloadPage()
          await loadDataInfoApi()
          loadAllQueueApi()
        }
      } else {
        reloadPage()
      }
    }
  }
}

async function reloadPage() {

  // The last "domLoading" Time //

  var currentDocumentTimestamp =

    new Date(performance.timing.domLoading).getTime();

  // Current Time //

  var now = Date.now();

  // Ten Seconds //

  var twoSec = 3 * 1000;

  // Plus Ten Seconds //

  var plusTwoSec = currentDocumentTimestamp + twoSec;

  if (now > plusTwoSec) {
    const lf = filterData(shop_seleted.value.uid, shopList.value)
    // console.log("Profile dash : " + JSON.stringify(lf[0]));
    await localStorage.setItem("shop_seleted", JSON.stringify(lf[0]));
    location.reload();
  } else {
    console.log("alredy loaded");
    // shop_seleted.value = JSON.parse(localStorage.getItem("shop_seleted"));
  }

}

function filterData(str, matchArr) {
  return matchArr.filter((c) => c.uid === str);
}


const loadAllQueueApi = async () => {
  const key = JSON.parse(localStorage.getItem("shop_seleted"));
  allqueuelist.value = []
  num_q01.value = 0
  num_q02.value = 0
  num_q03.value = 0
  num_q04.value = 0
  num_pay.value = 0
  list_q01.value = []
  list_q02.value = []
  list_q03.value = []
  list_q04.value = []
  list_pay.value = []
  user_q01.value = []
  user_q02.value = []
  user_q03.value = []
  user_q04.value = []
  user_pay.value = []

  let data = "";
  data = {
    index: '0',
    size: '100',
    shopUid: key.uid,
    groupUid: key.groupUid,
  };
  const payload = data;
  const response = await storew.listAllQueueFetch(payload);
  // console.log('AllQueue res : ' + JSON.stringify(response.data))
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        allqueuelist.value = response.data.data.list;

        list_q01.value = allqueuelist.value.filter((c) => c.queue.code === 'Q01');
        num_q01.value = list_q01.value.length
        if (list_q01.value.length > 0) {
          user_q01.value = list_q01.value.filter((obj, index, self) =>
            index === self.findIndex((t) => t.ownerUid === obj.ownerUid)
          );
          user_q01.value.sort((a, b) => Number(b.ownerUid) - Number(a.ownerUid));
        }

        list_q02.value = allqueuelist.value.filter((c) => c.queue.code === 'Q02');
        num_q02.value = list_q02.value.length
        if (list_q02.value.length > 0) {
          user_q02.value = list_q02.value.filter((obj, index, self) =>
            index === self.findIndex((t) => t.ownerUid === obj.ownerUid)
          );
          user_q02.value.sort((a, b) => Number(b.ownerUid) - Number(a.ownerUid));
        }

        list_q03.value = allqueuelist.value.filter((c) => c.queue.code === 'Q03');
        num_q03.value = list_q03.value.length
        if (list_q03.value.length > 0) {
          user_q03.value = list_q03.value.filter((obj, index, self) =>
            index === self.findIndex((t) => t.ownerUid === obj.ownerUid)
          );
          user_q03.value.sort((a, b) => Number(b.ownerUid) - Number(a.ownerUid));
        }

        list_q04.value = allqueuelist.value.filter((c) => c.queue.code === 'Q04');
        num_q04.value = list_q04.value.length
        if (list_q04.value.length > 0) {
          user_q04.value = list_q04.value.filter((obj, index, self) =>
            index === self.findIndex((t) => t.ownerUid === obj.ownerUid)
          );
          user_q04.value.sort((a, b) => Number(b.ownerUid) - Number(a.ownerUid));
        }

        list_pay.value = allqueuelist.value.filter((c) => c.step.name === 'Record Payment');
        num_pay.value = list_pay.value.length
        if (list_pay.value.length > 0) {
          user_pay.value = list_pay.value.filter((obj, index, self) =>
            index === self.findIndex((t) => t.ownerUid === obj.ownerUid)
          );
          user_pay.value.sort((a, b) => Number(b.ownerUid) - Number(a.ownerUid));
        }
      }
    }
  }

}


const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val)
}

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

function monthDiff() {
  let pro = false
  var months;
  months = (end_date.value.getFullYear() - start_date.value.getFullYear()) * 12;
  months += end_date.value.getMonth() - start_date.value.getMonth();

  if (months > 3) {
    pro = true
  }
  return pro
}

async function setnumOfTransaction() {
  legendTimes.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.numOfPawn),
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.numOfInterest),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.numOfInc),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.numOfDec),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.numOfRedeem),
    },
  ];


}

async function setnumOfAmount() {
  legendBaht.value = [
    {
      bg: "bg-pledge",
      hd: computed(() => t("content.actpawn1")),
      dt: Number(dataInfo.value.pawnAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmount),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmount),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmount),
    },
    {
      bg: "bg-redeem",
      hd: computed(() => t("content.actpawn5")),
      dt: Number(dataInfo.value.redeemAmount),
    },
  ];
}


async function setnumOfSum() {

  legendSum.value = [
    {
      bg: "bg-payment",
      hd: computed(() => t("content.amnoutcome")),
      dt: Number(dataInfo.value.pawnAmount) + Number(dataInfo.value.incAmount)
    },
    {
      bg: "bg-receive",
      hd: computed(() => t("content.amnincome")),
      dt: Number(dataInfo.value.decAmount) + Number(dataInfo.value.redeemAmount) + Number(dataInfo.value.interestAmount)
    },
    {
      bg: "bg-interest",
      hd: computed(() => t("content.amninterest")),
      dt: Number(dataInfo.value.sumInterest),
    },

  ];

}

async function setnumOfMig() {

  legendMig.value = [
    {
      bg: "bg-interest",
      hd: computed(() => t("content.actpawn2")),
      dt: Number(dataInfo.value.interestAmountMigration),
      dt2: Number(dataInfo.value.numOfInterestMigration),
    },
    {
      bg: "bg-add-cap",
      hd: computed(() => t("content.actpawn3")),
      dt: Number(dataInfo.value.incAmountMigration),
      dt2: Number(dataInfo.value.numOfIncMigration),
    },
    {
      bg: "bg-reduce-cap",
      hd: computed(() => t("content.actpawn4")),
      dt: Number(dataInfo.value.decAmountMigration),
      dt2: Number(dataInfo.value.numOfDecMigration),
    },

  ];

}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatDecimalString(num) {
  num = Number(num)
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberString(num) {
  num = Number(num)
  if (num === null || num === undefined) {
    num = 0
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );

}


async function viewUserWorkDetail(val) {
  userq.value = val
  list_userq.value = []
  if (userq.value === 'Q01') {
    list_userq.value = user_q01.value
  } else if (userq.value === 'Q02') {
    list_userq.value = user_q02.value
  } else if (userq.value === 'Q03') {
    list_userq.value = user_q03.value
  } else if (userq.value === 'Q04') {
    list_userq.value = user_q04.value
  } else if (userq.value === 'QPAY') {
    list_userq.value = user_pay.value
  }
  document.getElementById("userWorkModalShow").click();
}

function sumUserWork(ownerUid) {
  let array = []
  if (userq.value === 'Q01') {
    array = list_q01.value
  } else if (userq.value === 'Q02') {
    array = list_q02.value
  } else if (userq.value === 'Q03') {
    array = list_q03.value
  } else if (userq.value === 'Q04') {
    array = list_q04.value
  } else if (userq.value === 'QPAY') {
    array = list_pay.value
  }
  let sum = array.filter((c) => c.ownerUid === ownerUid).length;
  return sum
}

</script>

<style lang="scss" scoped></style>